import { render } from "./MainMonitor.vue?vue&type=template&id=22a93998&scoped=true"
import script from "./MainMonitor.vue?vue&type=script&lang=js"
export * from "./MainMonitor.vue?vue&type=script&lang=js"

import "./MainMonitor.vue?vue&type=style&index=0&id=22a93998&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a93998"]])

export default __exports__